/* eslint-disable camelcase */
import { createBookURL } from '../../../profile/body-section/body-sub-sections/PracticeStaff/createBookUrl';
import { MyCareTeamPractice, MyCareTeamPractitioner } from './types';

export const generateMyCareTeamPractitionerBookUrl = ({
  practitioner,
  practitioner_id,
}: MyCareTeamPractitioner) => {
  if (practitioner && practitioner_id) {
    const firstPractice = practitioner.practices[0];

    const apptDocId = String(firstPractice?.appt_practitioner ?? 0);

    if (firstPractice)
      return createBookURL(String(firstPractice.id), {
        practitionerProfileId: apptDocId,
        id: apptDocId,
      });

    return null;
  }

  return null;
};

export const generateMyCareTeamPracticeBookUrl = ({
  practice,
  practice_id,
}: MyCareTeamPractice) => {
  if (practice && practice_id) {
    return createBookURL(practice_id, {
      practitionerProfileId: '0',
      id: '0',
    });
  }

  return null;
};
